
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.083 0a7.09 7.09 0 00-6.74 4.883 7.003 7.003 0 00-4.67 3.386 7.046 7.046 0 00.873 8.267 6.94 6.94 0 00.597 5.718 7.084 7.084 0 007.614 3.395 6.996 6.996 0 005.26 2.35 7.093 7.093 0 006.741-4.882 6.97 6.97 0 004.662-3.384 7.033 7.033 0 00-.864-8.27v-.008a6.964 6.964 0 00-.598-5.728 7.085 7.085 0 00-7.604-3.385A7.028 7.028 0 0013.084 0zm0 1.82l-.009.01a5.26 5.26 0 013.37 1.213c-.039.019-.114.067-.17.095L10.69 6.353a.907.907 0 00-.455.796v7.547l-2.402-1.384V7.073a5.254 5.254 0 015.25-5.253zm6.725 2.198a5.256 5.256 0 014.564 2.63 5.265 5.265 0 01.626 3.507c-.039-.028-.113-.066-.161-.094l-5.582-3.225a.936.936 0 00-.92 0l-6.542 3.775V7.84l5.4-3.119a5.235 5.235 0 012.615-.704zM6.001 6.883v6.627c0 .331.17.626.455.796l6.531 3.763-2.411 1.394-5.393-3.11a5.247 5.247 0 01.818-9.47zm12.512 1.641l5.402 3.11a5.237 5.237 0 011.918 7.168l.009.01a5.243 5.243 0 01-2.734 2.294v-6.628a.907.907 0 00-.455-.796l-6.54-3.775 2.4-1.383zm-3.968 2.285L17.3 12.4v3.176l-2.754 1.592-2.753-1.592v-3.176l2.753-1.592zm4.33 2.503l2.401 1.384v6.23c0 2.9-2.354 5.253-5.25 5.253v-.01a5.243 5.243 0 01-3.36-1.214c.038-.018.123-.066.17-.094l5.581-3.214a.888.888 0 00.455-.796l.002-7.54zm-1.568 4.078v2.769l-5.402 3.11c-2.517 1.441-5.724.588-7.177-1.916h.01a5.202 5.202 0 01-.628-3.508c.039.028.114.066.16.094l5.583 3.225a.937.937 0 00.92 0l6.534-3.774z","fill":"#fff"}})])
          )
        }
      }
    